export const TRADING_SOURCE_INTERNAL: string = "INTERNAL";
export const TRADING_SOURCE_FXALL: string = "FXALL";
export const TRADING_SOURCE_FIX: string = "FIX";
export const TRADING_SOURCE_BLMBRG: string = "BLMBRG";
export const TRADING_SOURCE_SDP: string = "SDP";
export const TRADING_SOURCE_RSRVD2: string = "RSRVD2";
export const TRADING_SOURCE_FXC: string = "FXC";
export const TRADING_SOURCE_FIX360T: string = "FIX360T";
export const TRADING_SOURCE_AUTO: string = "AUTO";
export const TRADING_SOURCE_CUSTOM: string = "CUSTOM";
